/**
 * The dropdown lists, carried over from the old app unchanged.
 *
 * Ported verbatim on purpose (Mike, 2026-08-22): existing accounts hold these
 * exact strings, so editing the list would orphan a stored value — a company
 * that picked "Software & IT" would find its industry blank the next time it
 * opened Settings. Countries are not duplicated here; v2 already has the list
 * in lib/countries.ts and the deal forms use it.
 */

/** Employee-count buckets, from the old `FTE_BUCKETS`. */
export const COMPANY_SIZES = [
  '1-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1,000',
  '1,001-5,000',
  '5,001-10,000',
  '10,000+',
] as const

/** From the old `INDUSTRIES`, in the same order — it is not alphabetical, and
 *  "Other" stays last. */
export const INDUSTRIES = [
  'Software & IT',
  'Financial Services',
  'Healthcare & Pharma',
  'Manufacturing',
  'Retail & E-commerce',
  'Professional Services',
  'Media & Entertainment',
  'Telecommunications',
  'Energy & Utilities',
  'Transportation & Logistics',
  'Real Estate',
  'Education',
  'Government & Public Sector',
  'Hospitality & Travel',
  'Construction',
  'Automotive',
  'Consumer Goods',
  'Non-profit',
  'Other',
] as const

/**
 * Report language. `match` writes each summary in the language of its own call;
 * the other four force one language regardless. Values are the backend's
 * (`users.report_language`), not display strings.
 */
export const REPORT_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'nl', label: 'Dutch' },
  { value: 'de', label: 'German' },
  { value: 'fr', label: 'French' },
  { value: 'match', label: 'Match the call' },
] as const

/** A "not set" entry, so an empty stored value is selectable rather than implied. */
export const NOT_SET = { value: '', label: 'Not set' }

export const asOptions = (values: readonly string[]) => [NOT_SET, ...values.map((v) => ({ value: v, label: v }))]
